import React from 'react';
import { withRouter } from 'react-router-dom';
import { testResultsFilesStore } from './TestResultsFilesStore';
import { TestResultsFilesTable } from './TestResultsFilesTable';
import { Pagination } from 'ats/components/pagination/Pagination';
import { TestResultsFilesImport } from './TestResultsFilesImport';
import { ListStore } from '../../shared/stores/ListStore';
import { observer } from 'mobx-react';
import { dialogStore } from '../layout/modals/DialogStore';
import { rolesAllowed, USER_ROLES } from '../../shared/security/RolesAllowed';
import SettingsSubsectionHeader from '../settings/SettingsSubsectionHeader';
import SettingsListToolbar from '../settings/SettingsListToolbar';
import SettingsListEmptyState from '../settings/SettingsListEmptyState';
import { getSettingsSectionLabel } from '../settings/settingsSections';

@rolesAllowed([USER_ROLES.ADMIN, USER_ROLES.MANAGER])
@withRouter
@observer
export class TestResultsFiles extends React.Component {
	constructor(props) {
		super(props);
		this.listStore = new ListStore(testResultsFilesStore, {
			entityName: 'Test Results File',
			createModalTitle: 'Import Test Results File ',
			createModal: (
				<TestResultsFilesImport handleSuccess={() => this.listStore.search()} />
			)
		});
	}

	componentDidMount() {
		const resetQuery = this.preSetQuery();
		this.listStore.search(resetQuery);
	}

	preSetQuery() {
		this.listStore.store.setQuery('sort', { column: 'createdAt', asc: true });
		this.listStore.store.setQuery(
			'pagination',
			this.listStore.store.defaultPagination
		);
		return false;
	}

	render() {
		const isEmpty = !this.listStore.loading && this.listStore.data.length === 0;

		return (
			<div className="TestResultsFiles container">
				<SettingsSubsectionHeader
					title={getSettingsSectionLabel('test-results-files')}
					actions={
						<SettingsListToolbar
							showSearch={false}
							createLabel="Upload Test Results File"
							onCreate={() => this.listStore.handleCreate()}
						/>
					}
				/>
				<div className="columns">
					<div className="column is-12 table-wrapper">
						<TestResultsFilesTable
							data={this.listStore.data}
							loading={this.listStore.loading}
							isEmpty={isEmpty}
							sort={this.listStore.store.query.sort}
							onSort={this.listStore.handleSort}
							onEdit={this.handleUpdateWithoutModal}
							onDisable={item => this.listStore.handleDisable(item, true)}
							onDelete={this.handleDelete}
							onDownload={item => this.listStore.store.downloadFile(item)}
						/>
						{!this.listStore.loading && isEmpty ? (
							<SettingsListEmptyState
								entityPlural="test results files"
								hasFilters={false}
							/>
						) : null}
					</div>
				</div>
				<div className="columns">
					<div className="column is-12 bottom-pagination">
						<Pagination
							loading={this.listStore.loading}
							pagination={testResultsFilesStore.query.pagination}
							totalResults={testResultsFilesStore.query.pagination.totalResults}
							onPaginationChange={this.listStore.handlePaginationChange}
						/>
					</div>
				</div>
			</div>
		);
	}

	handleDelete = item => {
		dialogStore.openDialog(
			{
				title: 'Delete Test Result File',
				message: `Are you sure you want to delete ${item.filename}?`,
				confirmLabel: 'Delete',
				confirmButtonClass: 'is-danger'
			},
			() => {
				this.listStore.deleteFromDialog(item);
			}
		);
	};
}
